import React from 'react';
import AuctionStore from '../stores/AuctionStore';
import AuthStore from '../stores/AuthStore';
import BidStore from '../stores/BidStore';
import MessageStore from '../stores/MessageStore';
import ProviderStore from '../stores/ProviderStore';
import UIStore from '../stores/UIStore';
import WebSocketStore from '../stores/WebSocketStore';
import DebuggerStore from './../stores/DebuggerStore';

const authStore = new AuthStore();
const auctionStore = new AuctionStore();
const providerStore = new ProviderStore();
const bidStore = new BidStore(auctionStore, providerStore);
const messageStore = new MessageStore(auctionStore);
const debuggerStore = new DebuggerStore(authStore, bidStore, auctionStore);
const webSocketStore = new WebSocketStore(
  authStore,
  auctionStore,
  bidStore,
  messageStore,
  providerStore,
  debuggerStore,
);
const uiStore = new UIStore(webSocketStore);

const storesContext = React.createContext({
  AuctionStore: auctionStore,
  AuthStore: authStore,
  BidStore: bidStore,
  DebuggerStore: debuggerStore,
  MessageStore: messageStore,
  ProviderStore: providerStore,
  UIStore: uiStore,
  WebSocketStore: webSocketStore,
});

export default storesContext;
